import { useEffect, useState } from "react";
import styles from "./inventoryData.module.css";
import { Tab, Tabs } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { AddProduct } from "../addProduct/AddProduct";
import { useDispatch, useSelector } from "react-redux";
import {
  productsApi,
  useGetProductsQuery,
} from "../../features/api/products/productsApi";
import { CommonFilter } from "../common/textFilter/CommonFilter";

export const InventoryData = () => {
  const [key, setKey] = useState("Product List");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Pagination States
  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [totalPages, setTotalPages] = useState(null);
  const [products, setProducts] = useState([]);
  const productFilter = useSelector((state) => state.commonFilter);

  // Fetching data from API
  const { data, isLoading, isError } = useGetProductsQuery({
    page: pageNo,
    size: pageSize,
    ...productFilter,
  });

  // Function to fetch next page of products
  const getNextPage = (page) => {
    dispatch(
      productsApi.endpoints.getProducts.initiate({
        page: page,
        size: pageSize,
        ...productFilter,
      })
    );
  };

  // Handle page change
  const handlePageChange = (newPage) => {
    if (newPage >= 0) {
      setPageNo(newPage);
      getNextPage(newPage);
    }
  };

  // Handle page size change
  const handlePageSizeChange = (event) => {
    const newSize = Number(event.target.value);
    setPageSize(newSize);
    setPageNo(0); // Reset to first page when page size changes
    getNextPage(0); // Fetch data for the first page with new page size
  };

  // When data is fetched, update the products state
  useEffect(() => {
    if (data?.content) {
      setProducts(data.content);
      setTotalPages(data.totalPages);
    }
  }, [data]);

  return (
    <div className="container pt-5">
      <Tabs
        id="controlled-tab"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-3"
      >
        <Tab eventKey="Product List" title="Product List">
          <CommonFilter
            filterBy={"productName"}
            placeHolder={"Aafi Mango Juice"}
            label={"Product Name"}
          />
          <div className={styles.tableContainer}>
            {isLoading ? (
              <p>Loading...</p>
            ) : isError ? (
              <p>Error fetching data</p>
            ) : (
              <>
                <table className={styles.customTable}>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>SKU</th>
                      <th>Product Name</th>
                      <th>Category</th>
                      <th>Stock</th>
                      <th>Price (€)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {products.length > 0 ? (
                      products.map((product, idx) => (
                        <tr
                          key={product.sku}
                          onClick={() => navigate(`/product/${product.id}`)}
                        >
                          <td>{pageNo * pageSize + idx + 1}</td>
                          <td>{product.sku}</td>
                          <td className={styles.capitalize}>{product.name}</td>
                          <td className={styles.capitalize}>
                            {product.category}
                          </td>
                          <td>{product.unit}</td>
                          <td>€{product.sellingPrice}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className={styles.noData}>
                          No products found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {/* Pagination Controls */}
                <div className={styles.pagination}>
                  {/* Page Size Selector */}
                  <div className={styles.pageSizeSelector}>
                    <label htmlFor="pageSize">Page Size: </label>
                    <select
                      id="pageSize"
                      value={pageSize}
                      onChange={handlePageSizeChange}
                    >
                      <option value={5}>5</option>
                      <option value={10}>10</option>
                      <option value={15}>15</option>
                    </select>
                  </div>
                  <button
                    onClick={() => handlePageChange(pageNo - 1)}
                    disabled={pageNo === 0}
                  >
                    Previous
                  </button>
                  <span>
                    Page {pageNo + 1} of {totalPages}
                  </span>
                  <button
                    onClick={() => handlePageChange(pageNo + 1)}
                    disabled={
                      !data?.content?.length || totalPages === pageNo + 1
                    }
                  >
                    Next
                  </button>
                </div>
              </>
            )}
          </div>
        </Tab>

        <Tab eventKey="Add Product" title="Add Product">
          <AddProduct />
        </Tab>
      </Tabs>
    </div>
  );
};
